//# sourceMappingURL=connection.mjs.map
/// <reference types="./connection.d.mts" />
import * as $json from "../../../gleam_json/gleam/json.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import * as $decrypt from "../../decrypt.mjs";
import { toList, CustomType as $CustomType } from "../../gleam.mjs";

export class Connection extends $CustomType {
  constructor(id, name, display_name) {
    super();
    this.id = id;
    this.name = name;
    this.display_name = display_name;
  }
}
export const Connection$Connection = (id, name, display_name) =>
  new Connection(id, name, display_name);
export const Connection$isConnection = (value) => value instanceof Connection;
export const Connection$Connection$id = (value) => value.id;
export const Connection$Connection$0 = (value) => value.id;
export const Connection$Connection$name = (value) => value.name;
export const Connection$Connection$1 = (value) => value.name;
export const Connection$Connection$display_name = (value) => value.display_name;
export const Connection$Connection$2 = (value) => value.display_name;

export function decoder() {
  return $decode.field(
    "id",
    $decode.string,
    (id) => {
      return $decode.field(
        "name",
        $decode.string,
        (name) => {
          return $decrypt.optional_field(
            "display_name",
            $decode.string,
            (display_name) => {
              return $decode.success(new Connection(id, name, display_name));
            },
          );
        },
      );
    },
  );
}

export function encode(connection) {
  return $json.object(
    toList([
      ["id", $json.string(connection.id)],
      ["name", $json.string(connection.name)],
      ["display_name", $json.nullable(connection.display_name, $json.string)],
    ]),
  );
}

/**
 * What the SPAs actually do with a connection: show its friendly name, or
 * fall back to the technical one when Auth0 has none.
 */
export function label(connection) {
  return $option.unwrap(connection.display_name, connection.name);
}
